import { Button, Icon, Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import clsx from 'clsx';
import { Link } from 'react-router-dom';

function PageHeaderBackButton(props) {
	const theme = useTheme();
	const {
		to,
		onClick,
		label = 'Back',
		variant = 'link',
		className,
		color = 'inherit',
		buttonVariant = 'contained',
		size,
		iconClassName,
		textClassName = 'hidden sm:flex mx-4 font-medium',
		disableLeftPadding = false
	} = props;

	const icon = theme.direction === 'ltr' ? 'arrow_back' : 'arrow_forward';
	const componentProps = to ? { component: Link, to } : {};
	const leftPaddingClassName = disableLeftPadding ? null : 'pl-12';

	if (variant === 'button') {
		return (
			<Button
				{...componentProps}
				className={clsx(leftPaddingClassName, className || 'whitespace-nowrap mx-4')}
				variant={buttonVariant}
				color={color}
				size={size}
				onClick={onClick}
				startIcon={<Icon className={iconClassName || 'hidden sm:flex'}>{icon}</Icon>}
			>
				{label}
			</Button>
		);
	}

	return (
		<Typography
			{...componentProps}
			className={clsx(leftPaddingClassName, className || 'flex items-center sm:mb-12')}
			component={to ? Link : Button}
			role="button"
			onClick={onClick}
			color={color}
		>
			<Icon className={iconClassName || 'text-20'}>{icon}</Icon>
			<span className={textClassName}>{label}</span>
		</Typography>
	);
}

export default PageHeaderBackButton;
